import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class ToastService {
  // Reusable SweetAlert2 mixin configured as a top-right auto-dismissing toast.
  private toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (el) => {
      el.addEventListener('mouseenter', Swal.stopTimer);
      el.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });

  private fire(icon: SweetAlertIcon, msg: string, title: string) {
    this.toast.fire({ icon, title, text: msg });
  }

  success(msg: string, title = 'Success') {
    this.fire('success', msg, title);
  }

  error(msg: string, title = 'Error') {
    this.fire('error', msg, title);
  }

  warning(msg: string, title = 'Warning') {
    this.fire('warning', msg, title);
  }

  info(msg: string, title = 'Info') {
    this.fire('info', msg, title);
  }

  /**
   * Centered modal popup with a confirm button — use for messages that need
   * the user's acknowledgement rather than a transient toast.
   */
  popup(msg: string, title = '', icon: SweetAlertIcon = 'info') {
    return Swal.fire({ icon, title, text: msg, confirmButtonText: 'OK' });
  }

  /** Confirmation dialog. Resolves to true when the user confirms. */
  async confirm(msg: string, title = 'Are you sure?', confirmButtonText = 'Yes') {
    const result = await Swal.fire({
      icon: 'warning',
      title,
      text: msg,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    });
    return result.isConfirmed;
  }
}
